const MAX_CONCURRENT = 5;
let queue = [];
let active = 0;
let observer = null;

function flush() {
    while (active < MAX_CONCURRENT && queue.length > 0) {
        load(queue.shift());
    }
}

function load(img) {
    active++;
    const src = img.dataset.lazySrc;
    const temp = new Image();
    temp.onload = function () {
        img.src = src;
        active--;
        flush();
    };
    temp.onerror = function () {
        active--;
        flush();
    };
    temp.src = src;
}

function getObserver() {
    if (!observer) {
        observer = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
                if (entry.isIntersecting) {
                    observer.unobserve(entry.target);
                    queue.push(entry.target);
                    flush();
                }
            });
        }, {rootMargin: '200px'});
    }
    return observer;
}

export function initializeLazyQueue() {
    const obs = getObserver();
    document.querySelectorAll('img[data-lazy-src]:not([data-lazy-initialized])').forEach(function (img) {
        img.setAttribute('data-lazy-initialized', 'y');
        obs.observe(img);
    });
}